(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alp-abandoned-checkout-popup"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    let cookie = document.cookie;
    if (cookie.includes('alp_abandoned_checkout_triggered=true')) {
      popupOpen();
      document.cookie = 'alp_abandoned_checkout_triggered=false; path=/; max-age=0';
    }

    let triggerButtons = document.querySelectorAll(`[type="submit"]#checkout, .alp-payment-button-wrapper`);
    triggerButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        document.cookie = 'alp_abandoned_checkout_triggered=true; path=/; max-age=86400';
      });
    });

    function globoPopupButtonControl(globoElement) {
      let interval = setInterval(() => {
        let button = globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]');
        let buttonText = button.textContent;
        if (buttonText.includes('Submit')) {
          globoElement.classList.add('is-last-step');
        } else {
          globoElement.classList.remove('is-last-step');
        }
      }, 400);

      let closeButton = globoElement.querySelectorAll('.header.dismiss , .overlay');
      closeButton.forEach(function (button) {
        button.addEventListener('click', function () {
          clearInterval(interval);
          if (globoElement.classList.contains('is-last-step')) {
            globoElement.querySelector('.gfb__footer.wizard__footer button[data-next-text]').click();
          }
        });
      });
    }

    function popupOpen() {
      let popupId = document.querySelector('.alp-abandoned-checkout-popup[data-id]').getAttribute('data-id');
      let delay = document.querySelector('.alp-abandoned-checkout-popup[data-delay]').getAttribute('data-delay');
      delay = parseInt(delay);
      if (popupId) {
        setTimeout(function () {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', popupId]);
          console.log('Abandoned checkout popup opened');
        }, delay);
      }
      //
      let globoElement = document.querySelector('.globo-formbuilder-popup');
      if (globoElement) {
        globoElement.querySelector('.globo-form .floating-button').click();
        // globoPopupButtonControl(globoElement);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["alp-dropdown-sub-mega-menu-v1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class MegaTab extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const tabs = this.querySelectorAll(`[data-menu-title]`);
        const content = this.querySelectorAll(`[data-tabs-content] > div`);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            tabs.forEach((item) => {
              item.classList.remove('active');
            });
            tab.classList.add('active');
            content.forEach((item) => {
              item.classList.add('hidden');
            });
            const target = content[index];
            target.classList.remove('hidden');
          });
        });
        content.forEach((item) => {
          item.classList.add('hidden');
        });
        content[0].classList.remove('hidden');
        tabs[0].classList.add('active');

        // swiper tab navigation
        const swiperNav = this.querySelector('.mega-category-nav-swiper-v1');
        const swiperNavList = this.querySelector('.mega-category-nav-swiper-v1-list');
        const swiperNavItems = swiperNavList.querySelectorAll('.swiper-slide');
        const swiperNavSwiper = new Swiper(swiperNav, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          breakpoints: {
            768: {
              spaceBetween: 24,
            },
          },
        });
        swiperNavItems.forEach((item) => {
          item.addEventListener('click', () => {
            swiperNavSwiper.slideTo(index);
          });
        });
      }
    }
    customElements.define('lx-mega-tab', MegaTab);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-discount-code-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#axx-discount-form');
    const input = form.querySelector('.axx-discount-code');
    const messageEl = form.querySelector('.axx-discount-message');
    const appliedContainer = form.querySelector('.axx-applied-discounts');
    const summaryContainer = document.querySelector('.axx-ajax-cart-discount-summary');

    if (!form || !input || !messageEl || !appliedContainer) return;

    // --- Helpers -------------------------------------------------------------

    // Fetch the current cart JSON
    function fetchCart() {
      return fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    }

    // Extract discount codes from the cart JSON
    //
    // Depending on theme/Shopify version, discount codes may show as:
    // - cart.cart_level_discount_applications (type: 'discount_code')
    // - or sometimes cart.discount_code / cart.discount_codes (older)
    //
    // We normalize to an array of { code, title }.
    function getDiscountCodesFromCart(cart) {
      const codes = [];

      // Newer style: cart_level_discount_applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          // Only include discount-code-based apps, skip automatic discounts
          if (app.type === 'discount_code' && app.code) {
            codes.push({
              code: app.code,
              title: app.title || app.code,
            });
          }
        });
      }

      // Older style: cart.discount_code (single) or cart.discount_codes (array)
      if (!codes.length && cart.discount_code) {
        codes.push({ code: cart.discount_code, title: cart.discount_code });
      }

      if (!codes.length && Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach((dc) => {
          if (dc.code) {
            codes.push({ code: dc.code, title: dc.code });
          }
        });
      }

      return codes;
    }

    // Build the `discount` string for /cart/update.js from a list of codes
    // e.g. ['SAVE10','SHIPFREE'] -> 'SAVE10,SHIPFREE'
    function formatDiscountString(codes) {
      return codes.join(',');
    }

    // Render applied discount codes under the input
    function renderAppliedDiscounts(codes) {
      if (!codes.length) {
        appliedContainer.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'applied-discount-list';

      codes.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'applied-discount-item';

        const codeSpan = document.createElement('span');
        codeSpan.className = 'applied-discount-code';
        codeSpan.textContent = item.code;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'applied-discount-remove';
        removeBtn.setAttribute('aria-label', `Remove discount code ${item.code}`);
        removeBtn.textContent = '×'; // Remove icon

        removeBtn.addEventListener('click', () => {
          removeDiscountCode(item.code);
        });

        li.appendChild(codeSpan);
        li.appendChild(removeBtn);
        list.appendChild(li);
      });

      appliedContainer.innerHTML = '';
      appliedContainer.appendChild(list);
    }

    // Apply ALL discount codes to the cart via /cart/update.js
    function updateCartDiscounts(codes) {
      const discountString = codes.length ? formatDiscountString(codes) : '';

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      }).then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw data;
          });
        }
        return response.json();
      });
    }

    function showMessage(message) {
      messageEl.textContent = message;
      messageEl.classList.remove('hidden');
      setTimeout(() => {
        messageEl.classList.add('hidden');
      }, 4000);
    }

    // Remove a single code from the list and update the cart
    function removeDiscountCode(codeToRemove, message) {
      form.classList.add('loading');
      fetchCart()
        .then((cart) => {
          const codes = getDiscountCodesFromCart(cart).map((c) => c.code);
          const remaining = codes.filter((c) => c !== codeToRemove);

          return updateCartDiscounts(remaining);
        })
        .then((updatedCart) => {
          showMessage(message || `${codeToRemove} removed.`);

          const currentCodes = getDiscountCodesFromCart(updatedCart).map((c) => c.code);
          renderAppliedDiscounts(getDiscountCodesFromCart(updatedCart));

          // Optionally: refresh totals / cart UI from updatedCart
          console.log('Updated cart after removing code:', updatedCart);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // refresh cart
          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error removing discount:', error);
          showMessage('Unable to remove discount. Please try again.');
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Init: fetch cart and render applied codes --------------------------

    async function init() {
      fetchCart()
        .then((cart) => {
          // const codes = getDiscountCodesFromCart(cart);
          // renderAppliedDiscounts(codes);
          form.classList.add('loading');
          let AllCodes = cart.discount_codes;
          let appliedCodes = [];
          AllCodes.forEach((code) => {
            if (code.applicable) {
              appliedCodes.push(code.code);
            }
          });
          appliedCodesToStr = appliedCodes.join(',');
          let updates = {
            discount: appliedCodesToStr,
          };
          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(updates),
          })
            .then((response) => response.json())
            .then((data) => {
              // console.log(data);
              const codes = getDiscountCodesFromCart(data);
              renderAppliedDiscounts(codes);
              console.log('Applied discount codes:', codes);

              // update discount summary
              const grouped = getGroupedDiscountsFromCart(data);
              renderDiscountSummary(summaryContainer, grouped);

              form.classList.remove('loading');
            });
        })
        .catch((err) => {
          console.error('Error fetching cart:', err);
          form.classList.remove('loading');
        });
    }

    window.addEventListener('refreshAjaxCart', init);

    // add newCode
    function addNewCode(newCode) {
      form.classList.add('loading');
      // Strategy:
      // 1. Fetch current cart & existing codes
      // 2. Add new code to the list (if not already present)
      // 3. POST all codes as a single string to cart/update.js
      fetchCart()
        .then((cart) => {
          const existingCodes = getDiscountCodesFromCart(cart).map((c) => c.code.toLowerCase());

          const mergedCodes = [...new Set([...existingCodes, newCode.toLowerCase()])];

          return updateCartDiscounts(mergedCodes);
        })
        .then((updatedCart) => {
          // check if the discount is applicable, if not, show the error message and remove this discount code
          let thisCode = updatedCart.discount_codes.find((code) => code.code.toLowerCase() === newCode.toLowerCase());
          if (!thisCode.applicable) {
            console.log('Discount is not applicable:', thisCode);
            removeDiscountCode(thisCode.code.toLowerCase(), `${thisCode.code} is not applicable.`);
            input.value = '';
            return;
          }

          // showMessage('Discount applied.');

          input.value = '';

          const codes = getDiscountCodesFromCart(updatedCart);
          renderAppliedDiscounts(codes);

          // update discount summary
          const grouped = getGroupedDiscountsFromCart(updatedCart);
          renderDiscountSummary(summaryContainer, grouped);

          // Optionally: re-render cart totals, etc.
          console.log('Updated cart with discount(s):', codes);

          // refresh line item discount summary and cart

          AlpFn.refreshCart('[data-ajax-cart]');

          form.classList.remove('loading');
        })
        .catch((error) => {
          console.error('Error applying discount:', error);
          showMessage('Unable to apply this discount.');
          form.classList.remove('loading');
          input.value = '';
        });
    }

    // --- Form submit: apply a discount code ---------------------------------

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const newCode = input.value.trim();
      if (!newCode) {
        // showMessage('Please enter a discount code.');
        return;
      }

      addNewCode(newCode);
    });

    // discount-summary -----------------------------------

    // Build a friendly label from a discount_application / cart_level_discount_application
    function getDiscountLabel(app) {
      // Prefer a human-readable title; fallback to code; fallback to type
      return app.title || app.code || app.type || 'Discount';
    }

    // Returns array of { label, totalAmount } where totalAmount is a number (in shop currency)
    function getGroupedDiscountsFromCart(cart) {
      const groups = Object.create(null); // { [label]: totalAmountNumber }

      // 1) Line-item level discounts
      if (Array.isArray(cart.items)) {
        cart.items.forEach((item) => {
          if (!Array.isArray(item.line_level_discount_allocations)) return;

          item.line_level_discount_allocations.forEach((alloc) => {
            const app = alloc.discount_application || {};
            const label = getDiscountLabel(app);
            const amount = parseFloat(alloc.amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          });
        });
      }

      // 2) Cart-level discount applications
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach((app) => {
          let thisApp = app.discount_application || app;
          // console.log('cart_level_discount_applications:', thisApp);
          if (thisApp.type === 'discount_code') {
            const label = getDiscountLabel(thisApp);
            const amount = parseFloat(thisApp.total_allocated_amount || '0') || 0;

            if (!groups[label]) {
              groups[label] = 0;
            }
            groups[label] += amount;
          }
        });
      }

      // Convert map → array
      return Object.keys(groups).map((label) => ({
        label,
        totalAmount: groups[label],
      }));
    }

    function formatMoneyFromNumber(amount) {
      // amount is a number in store currency (e.g. 5 -> $5.00)
      // Use Shopify's money formatting if needed; this simple example uses Intl
      // Adjust currency code and locale to your store.
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.shopCurrentCurrency,
      }).format(amount);
    }

    function renderDiscountSummary(container, discounts) {
      if (!container) return;

      if (!discounts.length) {
        container.innerHTML = '';
        return;
      }

      const list = document.createElement('ul');
      list.className = 'discount-summary-list';

      discounts.forEach((d) => {
        const li = document.createElement('li');
        li.className = 'discount-summary-item';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'discount-summary-name';
        nameSpan.innerHTML = `${window.shopDiscountLabelSvgHtml} ${d.label}`;

        const amountSpan = document.createElement('span');
        amountSpan.className = 'discount-summary-amount';
        // Show as negative amount
        amountSpan.textContent = '-' + formatMoneyFromNumber(d.totalAmount / 100.0);

        li.appendChild(nameSpan);
        li.appendChild(amountSpan);
        list.appendChild(li);
      });

      container.innerHTML = '';
      container.appendChild(list);
    }

    window.refreshAjaxCartDiscountSummary = () => {
      fetchCart()
        .then((cart) => {
          const grouped = getGroupedDiscountsFromCart(cart);
          renderDiscountSummary(summaryContainer, grouped);
        })
        .catch((err) => {
          console.error('Error fetching cart for discounts:', err);
        });
    };

    init();
    // window.refreshAjaxCartDiscountSummary();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["axx-variants-swatch"] && !Shopify.designMode) return;
  try {
    window.AXXVariantsSwatch = class {
    // 选择器 [data-axx-swatch]
    // 父级 [data-product-swatch]
    // 图片 [data-product-swatch-images]
    // 价格容器 [data-product-swatch-price]
    // 价格值 [data-product-swatch-price-value]
    // 对比价格 [data-product-swatch-compare-price-value]
    // url [data-product-swatch-url]

    constructor() {
      this.products = [];
      // 存储事件处理函数
      this.eventListeners = new Map();
    }

    init() {
      this.products = document.querySelectorAll('[data-axx-swatch]');
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 创建事件处理函数
        const handler = (e) => this.handlerChange(product, form);
        // 存储事件处理函数
        this.eventListeners.set(form, handler);
        // 添加事件监听器
        form.addEventListener('change', handler);
      });
    }

    update() {
      this.products.forEach((product) => {
        let form = product.querySelector('form');
        // 获取存储的事件处理函数
        const handler = this.eventListeners.get(form);
        if (handler) {
          // 移除事件监听器
          form.removeEventListener('change', handler);
          // 清理存储的引用
          this.eventListeners.delete(form);
        }
      });
      this.products = [];
      this.init();
    }

    handlerChange(product, form) {
      const fieldsets = Array.from(form.querySelectorAll('[data-form-input]'));
      let options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      this.updateCurrentVariant(product, options);
    }

    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      const sortedArr1 = [...arr1].sort();
      const sortedArr2 = [...arr2].sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          return false;
        }
      }
      return true;
    }

    getVariantData(product) {
      let variantData = JSON.parse(product.querySelector('[type="application/json"]').textContent);
      return variantData;
    }

    updateCurrentVariant(product, options) {
      let currentVariant = null;
      this.getVariantData(product).find((variant) => {
        // match the current variant
        if (this.areArraysEqual(variant.options, options)) {
          currentVariant = variant;
        }
      });
      // console.log(currentVariant.id);
      if (currentVariant) {
        this.setProductInfo(product, currentVariant);
        this.updateVariantStatuses(product, currentVariant);
      }
    }

    updateVariantStatuses(product, currentVariant) {
      let $this = this;
      let forms = product.querySelector('form').querySelectorAll('[data-form-input]');
      if (forms.length < 2) {
        return;
      }
      // Disable all inputs
      forms.forEach((form) => {
        form.querySelectorAll('input').forEach((input) => {
          input.classList.add('disabled');
        });
      });
      // Enable only the matched inputs
      forms.forEach((form, index) => {
        let checkedInput = form.querySelector(':checked');
        let matchedVariants = $this
          .getVariantData(product)
          .filter((variant) => variant.options[index] === checkedInput.value);
        // console.log(matchedVariants);
        matchedVariants.forEach((variant) => {
          let available = variant.available;
          variant.options.forEach((option, optionIndex) => {
            if (optionIndex !== index) {
              // console.log(option);
              let optionInputs = forms[optionIndex].querySelectorAll(`input[value="${option}"]`);
              optionInputs.forEach((input) => {
                if (available) {
                  input.classList.remove('disabled');
                }
              });
            }
          });
        });
      });
    }

    setProductInfo(product, variant) {
      let productId = product.dataset.productId;
      let productUrl = product.dataset.productUrl;
      let productUrlWithVariant = productUrl + '?variant=' + variant.id;
      let productInfo = {
        id: variant.id,
        price: variant.price,
        compare_at_price: variant.compare_at_price,
        image: variant.featured_image.src,
        image_id: variant.featured_image.id,
        url: productUrlWithVariant,
        options: variant.options,
        available: variant.available,
      };
      this.updateProductInfo(product, productId, productInfo);
      this.sendCustomEvent(product, productId, 'variant:change', productInfo);
      // console log
      console.log(`SwatchChanged:[product:${productId}],[variant:${variant.id}]`);
    }

    updateProductInfo(product, productId, productInfo) {
      // match the parent element '[data-product-swatch]'
      let parent = product.closest('[data-product-swatch]');
      // update product data info
      if (parent) {
        parent.dataset.productInfo = JSON.stringify(productInfo);
        // update images src and srcset
        let images = parent.querySelectorAll(`[data-product-swatch-images]`);
        if (images) {
          images.forEach((image) => {
            let imageInfo = JSON.parse(image.querySelector('[type="application/json"]').textContent);
            imageInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                image.querySelector('img').src = variant.image.src;
                image.querySelector('img').srcset = variant.image.srcset;
              }
            });
          });
        }
        // update price
        let priceWarpper = parent.querySelectorAll('[data-product-swatch-price]');
        if (priceWarpper) {
          priceWarpper.forEach((price) => {
            let the_price = price.querySelector('[data-product-swatch-price-value]');
            let the_compare_price = price.querySelector('[data-product-swatch-compare-price-value]');
            let priceInfo = JSON.parse(price.querySelector('[type="application/json"]').textContent);
            priceInfo.variants.forEach((variant) => {
              if (variant.id === productInfo.id) {
                the_price.textContent = variant.price;
                the_compare_price.textContent = variant.compare_at_price;
                if (variant.compare_at_price) {
                  the_compare_price.classList.remove('hidden');
                } else {
                  the_compare_price.classList.add('hidden');
                }
              }
            });
          });
        }
        // update url
        let urlWarpper = parent.querySelectorAll('[data-product-swatch-url]');
        if (urlWarpper) {
          urlWarpper.forEach((url) => {
            url.setAttribute('href', productInfo.url);
          });
        }
      }
    }

    sendCustomEvent(product, productId, eventName, detail) {
      let parent = product.closest('[data-product-swatch]');
      if (parent) {
        let event = new CustomEvent(eventName, { detail });
        parent.dispatchEvent(event);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.axxVariantsSwatch = new window.AXXVariantsSwatch();
    window.axxVariantsSwatch.init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-variant-selector"] && !Shopify.designMode) return;
  try {
    class LXVariantSelector extends HTMLElement {
    constructor() {
      super();
      this._onFormChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantsScript = this.form.querySelector('script[type="application/json"]');
      this.variants = this.parseVariants();

      this.form.addEventListener('change', this._onFormChange);
      this.syncRadiosFromVariantId(this.dataset.productVariantId);
      this.applyCurrentVariant();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this._onFormChange);
    }

    parseVariants() {
      if (!this.variantsScript?.textContent) return [];
      try {
        const data = JSON.parse(this.variantsScript.textContent);
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    }

    /** 按 option position 顺序读取当前选中的选项值（与 JSON 里 option1/2/3 对齐） */
    getOptionGroups() {
      const root = this.querySelector('.lx-variant-selector__options');
      if (!root) return [];

      return Array.from(root.querySelectorAll('.lx-variant-selector__option')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    }

    getSelectedOptionValues() {
      return this.getOptionGroups().map((group) => {
        const input = group.querySelector('input[type="radio"]:checked');
        return input ? input.value : null;
      });
    }

    variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues) {
      if (variant[`option${posIndex + 1}`] !== candidateValue) return false;

      for (let j = 0; j < selectedValues.length; j += 1) {
        if (j === posIndex) continue;
        const sel = selectedValues[j];
        if (sel == null || sel === '') continue;
        if (variant[`option${j + 1}`] !== sel) return false;
      }

      return true;
    }

    /**
     * 当前选中值下，该维度取 candidateValue、其余维度沿用 selectedValues 时的组合状态。
     * selectedValues 中未选维度（null）不参与约束。
     * 返回 canPurchase、currentVariantNull（无变体行匹配该组合，例如仅有 Standard/Jungle Camo 而无 Large/Jungle Camo）。
     */
    hasAvailableVariantForCandidate(posIndex, candidateValue, selectedValues) {
      let hasAnyVariant = false;
      let hasAvailableVariant = false;

      for (const variant of this.variants) {
        if (!this.variantMatchesCandidate(variant, posIndex, candidateValue, selectedValues)) continue;
        hasAnyVariant = true;
        if (variant.available === true) hasAvailableVariant = true;
      }

      return {
        currentVariantNull: !hasAnyVariant,
        canPurchase: hasAvailableVariant,
      };
    }

    /**
     * 根据当前各组选中项，更新每组内 radio。
     * - 组合在 JSON 中不存在（currentVariantNull）：始终对非当前选中项设置 disabled，忽略 canDisableInputSelection。
     * - 组合存在但售罄：仅当 data-can-disable-input-selection 为 true 时设置 disabled。
     * 已选中的项不 disabled，避免无法改选。
     */
    updateVariantStatuses() {
      if (!this.form || !this.variants.length) return;

      const selectedValues = this.getSelectedOptionValues();
      const groups = this.getOptionGroups();
      const allowDisableForSoldOut = this.dataset.canDisableInputSelection === 'true';

      groups.forEach((group, posIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const { currentVariantNull, canPurchase } = this.hasAvailableVariantForCandidate(
            posIndex,
            input.value,
            selectedValues
          );

          let nativeDisabled = false;
          if (!input.checked) {
            if (currentVariantNull) {
              nativeDisabled = true;
            } else if (allowDisableForSoldOut && !canPurchase) {
              nativeDisabled = true;
            }
          }

          // input.disabled = nativeDisabled;
          input.classList.toggle('unavailable', nativeDisabled);
          input.parentElement.classList.toggle('unavailable', nativeDisabled);

          input.classList.toggle('disabled', currentVariantNull || !canPurchase);
        });
      });
    }

    findVariantByOptions(selectedValues) {
      if (!this.variants.length || selectedValues.some((v) => v == null || v === '')) {
        return null;
      }

      return (
        this.variants.find((variant) =>
          selectedValues.every((val, index) => {
            const key = `option${index + 1}`;
            return variant[key] === val;
          })
        ) || null
      );
    }

    syncRadiosFromVariant(variant) {
      if (!variant || !this.form) return;

      const groups = this.getOptionGroups();
      groups.forEach((group, index) => {
        const targetValue = variant[`option${index + 1}`];
        if (targetValue == null) return;

        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === targetValue;
        });
      });
    }

    findBestComposableVariant(changedPosIndex, changedValue, selectedValues) {
      const candidates = this.variants.filter((variant) => variant[`option${changedPosIndex + 1}`] === changedValue);
      if (!candidates.length) return null;

      const getScore = (variant) => {
        let score = variant.available ? 100 : 0;
        for (let i = 0; i < selectedValues.length; i += 1) {
          if (i === changedPosIndex) continue;
          const selected = selectedValues[i];
          if (selected && variant[`option${i + 1}`] === selected) score += 1;
        }
        return score;
      };

      let best = candidates[0];
      let bestScore = getScore(best);
      for (let i = 1; i < candidates.length; i += 1) {
        const current = candidates[i];
        const score = getScore(current);
        if (score > bestScore) {
          best = current;
          bestScore = score;
        }
      }

      return best;
    }

    syncRadiosFromVariantId(variantId) {
      if (!variantId || !this.variants.length) return;

      const variant = this.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      for (let i = 1; i <= 3; i += 1) {
        const val = variant[`option${i}`];
        if (val == null) continue;

        const inputs = this.form.querySelectorAll(`input[type="radio"][name="option-${i}"]`);
        inputs.forEach((input) => {
          input.checked = input.value === val;
        });
      }
    }

    updateProductInfo(variant, available = true) {
      // match element by [data-product-card] or [data-product-info]
      const productElement = this.closest('[data-product-card]') || this.closest('[data-product-info]');
      if (!productElement) return;
      //   update variant available
      productElement.dataset.variantAvailable = available;
      // update product variant id
      productElement.dataset.productVariantId = available ? String(variant.id) : '';
      // update add variant, match element by [data-add-variant]
      productElement.querySelectorAll('[data-add-variant]').forEach((element) => {
        element.dataset.addVariant = available ? String(variant.id) : '';
      });
      // update product link, match element by [data-product-link]
      productElement.querySelectorAll('[data-product-link]').forEach((element) => {
        element.href = available ? `${this.dataset.productUrl}?variant=${variant.id}` : `${this.dataset.productUrl}`;
      });
      // update product image, match element by [data-product-image]
      if (variant) {
        const imageWidth = Math.max(320, Math.min(800, window.innerWidth * 1.5));
        productElement.querySelectorAll('[data-product-image]').forEach((element) => {
          element.src = `${variant.featured_image.src}&width=${imageWidth}`;
        });
      }
      // update product price, match element by [data-product-price-element]
      if (variant) {
        let currency = Shopify.currency.active || 'USD';
        // let locale = `${Shopify.locale}-${Shopify.country}`;
        let locale = `EUR`;
        productElement.querySelectorAll('[data-product-price-element]').forEach((element) => {
          if (variant.price) {
            const priceFormat = (variant.price / 100).toLocaleString(locale, {
              style: 'currency',
              currency: currency,
            });
            element.querySelector('[data-product-price]').textContent = priceFormat;
          }
          if (variant.compare_at_price) {
            const comparePriceFormat = (variant.compare_at_price / 100).toLocaleString(locale, {
              style: 'currency',
              currency: currency,
            });
            element.querySelector('[data-product-compare-price]').textContent = comparePriceFormat;
          }
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            element.querySelector('[data-product-compare-price]').classList.remove('hidden');
          } else {
            element.querySelector('[data-product-compare-price]').classList.add('hidden');
          }
        });
      }
    }

    applyCurrentVariant() {
      const selectedValues = this.getSelectedOptionValues();
      const variant = this.findVariantByOptions(selectedValues);
      const productId = this.dataset.productId;

      if (variant) {
        this.dataset.productVariantId = String(variant.id);
        this.dataset.variantAvailable = variant.available;
        this.updateProductInfo(variant, variant.available);
      } else {
        this.dataset.variantAvailable = false;
        this.updateProductInfo(variant, false);
      }

      // get current option value text
      this.querySelectorAll('[data-option-value-text]:checked').forEach((element) => {
        const parentValueText = element
          .closest('.lx-variant-selector__option')
          .querySelector('.lx-variant-selector__option-value-text');
        if (parentValueText) {
          parentValueText.textContent = element.dataset.optionValueText;
        }
      });

      this.updateVariantStatuses();

      this.dispatchEvent(
        new CustomEvent('lx-variant-selector:change', {
          bubbles: true,
          detail: { variant, selectedValues, product: productId },
        })
      );

      return variant;
    }

    handleChange(event) {
      const target = event?.target;
      const isOptionInput =
        target instanceof HTMLInputElement &&
        target.type === 'radio' &&
        typeof target.name === 'string' &&
        target.name.startsWith('option-');

      if (isOptionInput) {
        const changedPosIndex = Number(target.name.replace('option-', '')) - 1;
        const selectedValues = this.getSelectedOptionValues();
        const currentVariant = this.findVariantByOptions(selectedValues);

        if (!currentVariant && changedPosIndex >= 0) {
          const fallbackVariant = this.findBestComposableVariant(changedPosIndex, target.value, selectedValues);
          if (fallbackVariant) {
            this.syncRadiosFromVariant(fallbackVariant);
          }
        }
      }

      this.applyCurrentVariant();
    }

    getCurrentVariant() {
      return this.findVariantByOptions(this.getSelectedOptionValues());
    }
  }

  if (!customElements.get('lx-variant-selector')) {
    customElements.define('lx-variant-selector', LXVariantSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-trustpilot"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {});
  } catch(e) { console.error(e); }
})();

})();
